/**
 * Badge — small label chip.
 * variants: live (pulsing red dot), hot (pink), new (purple), vip (gold), muted, success, danger
 */
export function Badge({ variant = "muted", className = "", children }) {
  const V = {
    live: "text-white bg-[color:var(--danger)]/20 border border-[color:var(--danger)] before:content-[''] before:w-1.5 before:h-1.5 before:rounded-full before:bg-[color:var(--danger)] before:animate-pulse before:mr-1.5 before:inline-block",
    hot: "text-white bg-brand-gradient",
    new: "text-white bg-[color:var(--brand-purple)]",
    vip: "text-[#0B0E1E] bg-gold-gradient font-semibold",
    muted: "text-ink-2 bg-highest border border-line",
    success: "text-[color:var(--success)] border border-[color:var(--success)]/50 bg-[color:var(--success)]/10",
    danger: "text-[color:var(--danger)] border border-[color:var(--danger)]/50 bg-[color:var(--danger)]/10",
    pink: "text-[color:var(--brand-pink)] border border-[color:var(--brand-pink)]/50 bg-[color:var(--brand-pink)]/10",
    gold: "text-[color:var(--brand-gold)] border border-[color:var(--brand-gold)]/50 bg-[color:var(--brand-gold)]/10",
  };
  return (
    <span
      className={
        "inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[10px] tracking-widest uppercase " +
        (V[variant] || V.muted) + " " + className
      }
    >
      {children}
    </span>
  );
}
